import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { DialogService } from '../../services/dialog.service'
import { IDialog } from '../../directives/dialog.directive'
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component'
import { MatDialog } from '@angular/material/dialog'
import { ThirdPartyNoticeComponent } from '@overtur-monorepo/phx-angular-material'
import { SupportTicketRequestModalComponent } from '../support-ticket-request-modal/support-ticket-request-modal.component'

@Component({
    selector: 'app-support',
    templateUrl: './support-modal.component.html',
    styleUrls: ['./support-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupportModalComponent implements IDialog<void> {
  data: void

  constructor(public dialogService: DialogService, private dialog: MatDialog) {}

  openSupportTicketModal() {
    this.dialogService.close(SupportModalComponent)
    this.dialog.open(SupportTicketRequestModalComponent)
  }

  openLicenceFile() {
    this.dialog.open(ThirdPartyNoticeComponent)
  }
}
